import InsightsBanner from './InsightsBanner'
export default InsightsBanner
